<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="模组厂商">
            <a-select
              v-decorator="['module_producer_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingProducerOptions"
              @change="handleProducerChange"
            >
              <a-select-option
                v-for="opt in producerOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="模组型号">
            <a-select
              v-decorator="['module_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请先选择模组厂商"
              :loading="loadingModelOptions"
            >
              <a-select-option
                v-for="opt in modelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['module_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="opt in supplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="IMEI">
            <a-input
              v-decorator="['imei', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="采购批次">
            <a-input
              v-decorator="['purchase_batch', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="箱号">
            <a-input
              v-decorator="['box_number', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="精确查询"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="盘号">
            <a-input
              v-decorator="['reel_number', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="精确查询"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="单价低于">
            <a-input-number
              v-decorator="['unit_price_lt']"
              :min="0"
              :precision="2"
              :step="0.01"
              style="width: 100%"
              placeholder="留空表示不限"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findModuleSuppliers } from '@/api/module_supplier'

export default {
  name: 'SearchModuleInventory',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'module_inventory_search' }),
      producerOptions: [],
      modelOptions: [],
      supplierOptions: [],
      loadingProducerOptions: false,
      loadingModelOptions: false,
      loadingSupplierOptions: false
    }
  },
  created() {
    this.fetchProducerOptions()
    this.fetchSupplierOptions()
  },
  methods: {
    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findModuleSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    fetchModelOptions(producerId) {
      this.loadingModelOptions = true
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    handleProducerChange(producerId) {
      this.form.setFieldsValue({ module_model_id: undefined })
      if (!producerId) {
        this.modelOptions = []
        return
      }
      this.fetchModelOptions(producerId)
    },

    handleSearch(e) {
      e.preventDefault()
      const v = this.form.getFieldsValue()
      const payload = {
        ...v,
        unit_price_lt: v.unit_price_lt != null && v.unit_price_lt !== '' ? v.unit_price_lt : undefined
      }
      this.$emit('submit', payload)
    },

    handleReset() {
      this.form.resetFields()
      this.modelOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
